// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConversionInput-module__container__WeA_1 {
  width: 100%;
}

.ConversionInput-module__containerCompact__kgzHO {
  width: auto;
}

.ConversionInput-module__containerCompactMobile__cQH2U {
  width: 100%;
}

.ConversionInput-module__fieldStackMobile__yPcDZ {
  width: 100%;
}

.ConversionInput-module__metricGroupMobile__YkIhg {
  width: 100%;
}

/* Text variant of the metric selector: the selected metric is the bold one. */
.ConversionInput-module__metricText__okkwH {
  font-size: var(--mantine-font-size-xs);
  line-height: 1.6;
  color: var(--mantine-color-dimmed);
}

.ConversionInput-module__metricText__okkwH[data-selected] {
  font-weight: 700;
  color: var(--mantine-color-text);
}

.ConversionInput-module__root__KzmK4 .mantine-InputBase-input {
  cursor: pointer;
  font-size: var(--mantine-font-size-sm);
}

.ConversionInput-module__placeholder__bntz7 {
  color: var(--mantine-color-placeholder);
}

.ConversionInput-module__selectedValue__rtqw3 {
  margin-left: 0.25rem;
}

.ConversionInput-module__optionLabel__jacSh {
  font-size: var(--mantine-font-size-sm);
}

.ConversionInput-module__dropdown__ylm9n .mantine-Combobox-search {
  padding: var(--mantine-spacing-xs);
}

.ConversionInput-module__dropdown__ylm9n .mantine-Combobox-search input {
  border: 1px solid var(--mantine-color-gray-3);
  border-radius: var(--mantine-radius-sm);
  font-size: var(--mantine-font-size-sm);
}

.ConversionInput-module__dropdown__ylm9n .mantine-Combobox-search input:focus {
  border-color: var(--mantine-color-dark-5);
}

.ConversionInput-module__dropdown__ylm9n .mantine-Combobox-option {
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
}

.ConversionInput-module__dropdown__ylm9n .mantine-Combobox-option[data-combobox-selected] {
  background-color: var(--mantine-primary-color-light);
}

.ConversionInput-module__dropdown__ylm9n .mantine-Combobox-option[data-combobox-active] {
  background-color: var(--mantine-color-gray-1);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/form/ConversionInput/ConversionInput.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,sCAAsC;EACtC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".container {\n  width: 100%;\n}\n\n.containerCompact {\n  width: auto;\n}\n\n.containerCompactMobile {\n  width: 100%;\n}\n\n.fieldStackMobile {\n  width: 100%;\n}\n\n.metricGroupMobile {\n  width: 100%;\n}\n\n/* Text variant of the metric selector: the selected metric is the bold one. */\n.metricText {\n  font-size: var(--mantine-font-size-xs);\n  line-height: 1.6;\n  color: var(--mantine-color-dimmed);\n}\n\n.metricText[data-selected] {\n  font-weight: 700;\n  color: var(--mantine-color-text);\n}\n\n.root :global(.mantine-InputBase-input) {\n  cursor: pointer;\n  font-size: var(--mantine-font-size-sm);\n}\n\n.placeholder {\n  color: var(--mantine-color-placeholder);\n}\n\n.selectedValue {\n  margin-left: 0.25rem;\n}\n\n.optionLabel {\n  font-size: var(--mantine-font-size-sm);\n}\n\n.dropdown :global(.mantine-Combobox-search) {\n  padding: var(--mantine-spacing-xs);\n}\n\n.dropdown :global(.mantine-Combobox-search input) {\n  border: 1px solid var(--mantine-color-gray-3);\n  border-radius: var(--mantine-radius-sm);\n  font-size: var(--mantine-font-size-sm);\n}\n\n.dropdown :global(.mantine-Combobox-search input:focus) {\n  border-color: var(--mantine-color-dark-5);\n}\n\n.dropdown :global(.mantine-Combobox-option) {\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\n}\n\n.dropdown :global(.mantine-Combobox-option[data-combobox-selected]) {\n  background-color: var(--mantine-primary-color-light);\n}\n\n.dropdown :global(.mantine-Combobox-option[data-combobox-active]) {\n  background-color: var(--mantine-color-gray-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ConversionInput-module__container__WeA_1`,
	"containerCompact": `ConversionInput-module__containerCompact__kgzHO`,
	"containerCompactMobile": `ConversionInput-module__containerCompactMobile__cQH2U`,
	"fieldStackMobile": `ConversionInput-module__fieldStackMobile__yPcDZ`,
	"metricGroupMobile": `ConversionInput-module__metricGroupMobile__YkIhg`,
	"metricText": `ConversionInput-module__metricText__okkwH`,
	"root": `ConversionInput-module__root__KzmK4`,
	"placeholder": `ConversionInput-module__placeholder__bntz7`,
	"selectedValue": `ConversionInput-module__selectedValue__rtqw3`,
	"optionLabel": `ConversionInput-module__optionLabel__jacSh`,
	"dropdown": `ConversionInput-module__dropdown__ylm9n`
};
module.exports = ___CSS_LOADER_EXPORT___;
